/* eslint-disable react-hooks/exhaustive-deps */
import React from 'react';
import { useHistory, useParams } from 'react-router'
import { LoadingAnimated as Loading } from '../../components'
import { store } from '../../effects/store'
import { updateCurrentSite } from '../../effects/actions'
 
const LoadingTest = ({ 
  className = "", 
  forceLogoOnly = true, 
  redirect = false,
  dark = false 
}) => {
  const history = useHistory()
  const { id } = useParams()

  const setSite = (id = null, redirectPath = "/", redirect = false) => {
    store.dispatch(updateCurrentSite(id))
    redirectEffect(redirect, redirectPath)
  }

  const redirectEffect = (redirect, redirectPath) => { redirect && setTimeout(() => { history.replace(redirectPath) }, 9500) }

  React.useEffect(() => {
    const hostname =  window.location.hostname
    const devEnvs = ["aw-proj22.s3-website.eu-west-2.amazonaws.com", "localhost"]
    const isProduction = process.env.REACT_APP_ENVIRONMENT === 'production' && !devEnvs.includes(hostname)
    const redirectWise = '/vr/showroom/12'
    const redirectWicanders = '/vr/showroom/12'
    const redirectFactory = '/splash'
    const redirectChoose = '/splash-split'
    if(redirect === true){
      if(id === "factory"){
        if(isProduction){
          if(hostname === "factory.amorimcorkflooring.com"){
            setSite("factory",redirectFactory, true)
          }
        }else{
          setSite("factory",redirectFactory, true)
        }
      }else if(id === "showroom"){
        if(isProduction){
          if(hostname === "factory.amorimcorkflooring.com"){
            setSite(null, redirectChoose, true)
          }else if(hostname === "showroom.amorimwise.com"){
            setSite("wise", redirectWise, true)
          }else if(hostname === "showroom.wicanders.com"){
            setSite("wicanders", redirectWicanders, true)
          }
        }else{
          setSite(null, redirectChoose, true)
        }
      }else if(id === "wise" && isProduction === false){
        setSite("wise", redirectWise, true)
      }else if(id === "wicanders" && isProduction === false){
        setSite("wicanders", redirectWicanders, true)
      }else if(id === undefined || id === ""){
        if(isProduction){
          if(hostname === "factory.amorimcorkflooring.com"){
            setSite(null, redirectChoose, true)
          }else if(hostname === "showroom.amorimwise.com"){
            setSite("wise", redirectWise, true)
          }else if(hostname === "showroom.wicanders.com"){
            setSite("wicanders", redirectWicanders, true)
          }
        }else{
          setSite("factory", redirectFactory, true)
        }
      }
    }
  }, [id])

  return (
    <Loading 
      dark={dark}
      forceLogoOnly={true}
      redirect={false}
      className={`relative vh-100 d-flex justify-content-center align-items-center z-index-20 no-touch ${className}`} 
    />
  )
}

export default React.memo(LoadingTest)
